import cloudinary from '../../../../../utils/cloudinary';

export default getImageLink;

function getImageLink(imageId, options) {
  options = Object.assign(
    {
      crop: 'limit'
    },
    options
  );

  return imageId && cloudinary.url(imageId, options);
}
